import React from "react";
import { sxToStyle } from "./materialCompat";

function mergeIconStyle(props) {
  var sxStyle = sxToStyle(props.sx);
  var namedSizes = {
    xs: 16,
    sm: 20,
    small: 20,
    md: 24,
    medium: 24,
    lg: 36,
    large: 36,
    xl: 48,
  };
  var requestedSize = props.size || props.fontSize;
  var size = namedSizes[requestedSize] || requestedSize || 24;
  var baseStyle = { width: size, height: size, fontSize: size };
  if (props.color) baseStyle.color = props.color;
  return Object.assign(baseStyle, sxStyle, props.style || {});
}

function Icon(props) {
  var children = props.children;
  var className = props.className;
  var title = props.title || props["aria-label"];
  var rest = Object.assign({}, props);
  delete rest.children;
  delete rest.className;
  delete rest.sx;
  delete rest.style;
  delete rest.fontSize;
  delete rest.size;
  delete rest.color;
  delete rest.title;

  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden={title ? undefined : "true"}
      role={title ? "img" : undefined}
      className={["legacy-ui-icon", className].filter(Boolean).join(" ")}
      style={mergeIconStyle(props)}
      focusable="false"
      {...rest}
    >
      {title ? <title>{title}</title> : null}
      {children}
    </svg>
  );
}

export function ArrowForwardIosRoundedIcon(props) {
  return (
    <Icon {...props}>
      <path fill="currentColor" d="M8.6 5.4c-.5.5-.5 1.2 0 1.7l4.9 4.9-4.9 4.9c-.5.5-.5 1.2 0 1.7s1.2.5 1.7 0l5.8-5.8c.5-.5.5-1.2 0-1.7L10.3 5.4c-.5-.5-1.3-.5-1.7 0z" />
    </Icon>
  );
}

export function ArrowRight(props) {
  return (
    <Icon {...props}>
      <path fill="currentColor" d="M10 5l7 7-7 7v-5H4v-4h6V5z" />
    </Icon>
  );
}

export function ArrowDropDownIcon(props) {
  return (
    <Icon {...props}>
      <path fill="currentColor" d="M7 9.5l5 5 5-5H7z" />
    </Icon>
  );
}

export function CloseRounded(props) {
  return (
    <Icon {...props}>
      <path fill="currentColor" d="M6.4 5.1L12 10.7l5.6-5.6c.4-.4 1.1-.4 1.5 0s.4 1.1 0 1.5L13.5 12l5.6 5.6c.4.4.4 1.1 0 1.5s-1.1.4-1.5 0L12 13.5l-5.6 5.6c-.4.4-1.1.4-1.5 0s-.4-1.1 0-1.5l5.6-5.6-5.6-5.6c-.4-.4-.4-1.1 0-1.5s1.1-.4 1.5.2z" />
    </Icon>
  );
}

export function PlayCircleIcon(props) {
  return (
    <Icon {...props}>
      <path fill="currentColor" d="M12 2a10 10 0 100 20 10 10 0 000-20zm-2.1 6.4l6.2 3.6-6.2 3.6V8.4z" />
    </Icon>
  );
}

export function PendingIcon(props) {
  return (
    <Icon {...props}>
      <path fill="currentColor" d="M12 2a10 10 0 100 20 10 10 0 000-20zM7 13.2a1.2 1.2 0 110-2.4 1.2 1.2 0 010 2.4zm5 0a1.2 1.2 0 110-2.4 1.2 1.2 0 010 2.4zm5 0a1.2 1.2 0 110-2.4 1.2 1.2 0 010 2.4z" />
    </Icon>
  );
}

export function FavoriteBorder(props) {
  return (
    <Icon {...props}>
      <path fill="currentColor" d="M19.7 5.3c-2-1.9-5.1-1.7-6.9.3l-.8.8-.8-.8c-1.8-2-4.9-2.2-6.9-.3-2.3 2.2-2.4 5.8-.2 8l7.2 7.2c.4.4 1 .4 1.4 0l7.2-7.2c2.2-2.2 2.1-5.8-.2-8zm-1.2 6.6L12 18.4l-6.5-6.5c-1.4-1.4-1.4-3.7.1-5 1.3-1.2 3.4-1 4.6.3l1.1 1.2c.4.5 1.2.5 1.6 0L14 7.2c1.2-1.3 3.3-1.5 4.6-.3 1.4 1.3 1.5 3.6-.1 5z" />
    </Icon>
  );
}

export function Favorite(props) {
  return (
    <Icon {...props}>
      <path fill="currentColor" d="M12 21.1l-1.4-1.3C5.4 15.1 2 12 2 8.2 2 5.1 4.4 2.8 7.5 2.8c1.7 0 3.4.8 4.5 2 1.1-1.2 2.8-2 4.5-2C19.6 2.8 22 5.1 22 8.2c0 3.8-3.4 6.9-8.6 11.6L12 21.1z" />
    </Icon>
  );
}

export function SettingsVoiceIcon(props) {
  return (
    <Icon {...props}>
      <path fill="currentColor" d="M12 14c1.7 0 3-1.3 3-3V5c0-1.7-1.3-3-3-3S9 3.3 9 5v6c0 1.7 1.3 3 3 3zm5.3-3c0 3-2.5 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.4 2.7 6.2 6 6.7V21h2v-3.3c3.3-.5 6-3.3 6-6.7h-1.7z" />
    </Icon>
  );
}

export function KeyboardArrowRightTwoToneIcon(props) {
  return (
    <Icon {...props}>
      <path fill="currentColor" d="M8.6 5.4L15.2 12l-6.6 6.6 1.8 1.8 8.4-8.4-8.4-8.4-1.8 1.8z" opacity=".75" />
    </Icon>
  );
}

export function PlayCircleFilledIcon(props) {
  return (
    <Icon {...props}>
      <path fill="currentColor" d="M12 2a10 10 0 100 20 10 10 0 000-20zM9.8 7.5l7 4.5-7 4.5v-9z" />
    </Icon>
  );
}

export function ChevronCompactLeftIcon(props) {
  return (
    <Icon {...props}>
      <path fill="currentColor" d="M15.7 4.3c.4.4.4 1 0 1.4L9.4 12l6.3 6.3c.4.4.4 1 0 1.4s-1 .4-1.4 0l-7-7c-.4-.4-.4-1 0-1.4l7-7c.4-.4 1-.4 1.4 0z" />
    </Icon>
  );
}

export function ChevronCompactRightIcon(props) {
  return (
    <Icon {...props}>
      <path fill="currentColor" d="M8.3 4.3c.4-.4 1-.4 1.4 0l7 7c.4.4.4 1 0 1.4l-7 7c-.4.4-1 .4-1.4 0s-.4-1 0-1.4l6.3-6.3-6.3-6.3c-.4-.4-.4-1 0-1.4z" />
    </Icon>
  );
}

export function ArrowLeftIcon(props) {
  return (
    <Icon {...props}>
      <path fill="currentColor" d="M14 5l-7 7 7 7v-5h6v-4h-6V5z" />
    </Icon>
  );
}

export function DesktopAccessDisabledIcon(props) {
  return (
    <Icon {...props}>
      <path fill="currentColor" d="M2.7 3.3L1.4 4.6l3 3V15c0 1.1.9 2 2 2H10v2H7v2h10v-2h-3v-2h2.7l2.7 2.7 1.3-1.3-18-18zM6.4 15V9.6l5.4 5.4H6.4zM20 5v9.2l-2-2V5H9.8l-2-2H20c1.1 0 2 .9 2 2v11.8l-2-2V5z" />
    </Icon>
  );
}

export default Icon;
